import { ItemTypeMetadata } from "../item-type-metadata.enum";
import { ValueItemMetadataBase } from "../item/value-item-metadata.model";
import { ToLayoutTypeMetadata } from "../layout-type-metadata.enum";
import { MetadataFactory } from "../metadata.factory";
import { ArrayJsonSchemaBase } from "../schema/array-json-schema.model";
import { ObjectJsonSchema } from "../schema/object-json-schema.model";
import { ExtendedLayoutMetadataBase } from "./extends-layout.metadata.model";
import { LayoutMetadata } from "./layout-metadata.model";
import { RowLayoutMetadata } from "./row-layout.metadata.model";

export class WebServiceLayoutMetadataBase extends ExtendedLayoutMetadataBase {

    datasource!: string

    constructor(type: string) {
        super(type)

        this.name = "Web service data"
        this.description = "Data del webservice"
        this.fieldName = "fieldName" + Math.floor(Math.random() * 1000000)
    }

    schema(schema: ObjectJsonSchema) {
        let schemaCurrent: ArrayJsonSchemaBase = new ArrayJsonSchemaBase(null)
        schema.properties[this.fieldName] = schemaCurrent
        schema.required.push(this.fieldName)
        this.items.forEach(i => {
            let row: RowLayoutMetadata = <RowLayoutMetadata> i
            row.schema(schemaCurrent.items)
        })
    }

    from(layout: LayoutMetadata): void {
        Object.assign(this, layout)
        for (let i = 0; i < this.items.length; i++) {
            const element = this.items[i]
            let type = ToLayoutTypeMetadata(element.type)
            if (type == null) continue

            let item = MetadataFactory.createLayoutFromType(type)
            item.from(element)
            this.items[i] = item
        }
    }

}

export interface WebServiceLayoutMetadata extends WebServiceLayoutMetadataBase { }